
import React from 'react';
import LegalHeader from '@/components/LegalHeader';
import Footer from '@/components/Footer';
import MobileNavBar from '@/components/mobile/MobileNavBar';
import { useEffect, useState } from 'react';
import { supabase } from '@/integrations/supabase/client';

const RiskDisclaimer = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
    const checkAuth = async () => {
      try {
        const { data: { session } } = await supabase.auth.getSession();
        setIsAuthenticated(!!session);
        
        if (session?.user?.id) {
          const { data: userRole } = await supabase
            .from('user_roles')
            .select('role')
            .eq('user_id', session.user.id)
            .single();
          
          setIsAdmin(userRole?.role === 'admin');
        }
      } catch (error) {
        console.error('Error checking auth:', error);
      } finally {
        setIsLoading(false);
      }
    };

    checkAuth();
  }, []);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleLogout = async () => {
    try {
      await supabase.auth.signOut();
    } catch (error) {
      console.error('Error logging out:', error);
    }
  };

  return (
    <div className="min-h-screen bg-white flex flex-col">
      <LegalHeader />
      <main className="flex-grow container mx-auto px-4 py-12 max-w-4xl pb-20 md:pb-12">
        <h1 className="text-3xl font-bold text-gray-900 mb-8">Disclaimer</h1>
        
        <div className="space-y-6 text-gray-600">
          <section className="space-y-4">
            <p>
              The provisions of this disclaimer apply to the entire contents of this website operated by AI BRAINVISUALS AG, based in Liechtenstein ("AI BRAINVISUALS"), under the domain https://www.metrade.io , of any related subdomains, or of any other AI BRAINVISUALS channel (e.g., social media; jointly: "Website"). Please read the following provisions carefully before using this Website. Reference is further made to our Terms of Use.
            </p>
            <p>
              AI BRAINVISUALS does not provide any advice of financial, tax, legal, or any other nature, nor any kind of investment advice or other recommendation to perform any transaction or operation. Also, AI BRAINVISUALS is neither licensed by, nor registered with, any financial market authority under the relevant financial market laws.
            </p>
          </section>

          <section className="space-y-4">
            <p>
              The content available on the Website or provided in any other form by AI BRAINVISUALS ("Content") is exclusively provided for information purposes only and is not intended to be contractual or binding on AI BRAINVISUALS or any of its affiliates in any way. Also, the Content does not take into consideration your or your client's specific investment objectives, financial situation, or particular needs, or of any other particular person. The Content shall under no circumstances be used or considered as any kind of financial, tax, or legal advice, and, in particular, not as an invitation, an offer, a solicitation, investment advice, or a recommendation to buy and/or sell (any kind of) digital assets and/or financial instruments or to engage in any other transactions or conclude any other legal acts.
            </p>
          </section>

          <section className="space-y-4">
            <p>
              AI BRAINVISUALS does not prepare any product information for financial instruments and the Content should not be construed as a prospectus or offering document. The Content does not constitute any decision-making aids for economic, legal, tax, or other advisory issues; therefore, you should not rely upon the Content or use it to form the definitive basis for any investment decision, contract, commitment, or action whatsoever, with respect to any proposed transaction or otherwise. All the investment decisions you make shall be based exclusively on your own assessment of the specific investment, your / your client's financial situation and your / your client's investment goals. You are solely responsible for such decisions. Prior professional advice by a qualified specialist is strongly recommended.
            </p>
          </section>

          <section className="space-y-4">
            <p>
              Trading digital assets like cryptocurrencies and/or financial instruments poses considerable risk of loss. Kindly use your judgement and do your own research at all times. You are solely responsible for your financial, investing, trading decisions, and/or any action you may take or decision you may make in reliance on any information on this Website – either for yourself or on behalf of your clients. Neither AI BRAINVISUALS nor any of its affiliates accept any responsibility or liability for any loss which may result from reliance on any of the information or opinions contained in or accessed through this Website. Any reliance you place on the Content is strictly at your own risk. In particular, the past performance of any investment or investment strategy is not indicative of future performance. The value of digital assets and/or financial instruments may be affected by changes in economic, financial or political factors, time to maturity, market conditions and volatility, or the credit quality of any issuer or reference issuer. Please seek the advice of professionals, as appropriate, regarding the evaluation of any specific information, opinion, advice, or other content.
            </p>
          </section>

          <section className="space-y-4">
            <p>
              AI BRAINVISUALS does not guarantee continuous, uninterrupted or secure access to this site. Although AI BRAINVISUALS uses reasonable efforts to include accurate and up to date information on this site, errors and omissions sometimes occur and this information may be incomplete, inaccurate, and out of date. AI BRAINVISUALS makes no commitment and disclaims any duty to update or correct any information on this site.
            </p>
          </section>

          <section className="space-y-4">
            <p>
              This Website may contain or contains content or items owned or originated by third parties ("Third Party Content"). All statements and opinions expressed in such Third-Party Content reflect solely the opinion(s) of the respective third party who may not be licensed by, nor registered with, a financial market authority under the relevant financial market laws.
            </p>
          </section>

          <section className="space-y-4">
            <p>
              AI BRAINVISUALS does not assume any responsibility for the accuracy, completeness, and legality of the product information provided by any third party. You acknowledge and agree that the Third-Party Content is not created or endorsed by AI BRAINVISUALS. The provision of Third-Party Content is for general informational purposes only and does not constitute any recommendation/advice or solicitation to do or omit to do any action (cf. our above remarks). You further acknowledge that the Third-Party Content provided to you is obtained from sources believed to be reliable and that no guarantees are made by AI BRAINVISUALS or the providers of the Third-Party Content as to its accuracy, completeness, and/or timeliness. In particular, no promise of profit and no representation with regard to the performance of digital assets and/or financial instruments is made with this Third-Party Content. You agree not to hold AI BRAINVISUALS, or any provider of Third-Party Content liable for any decisions or actions which you may make or take based on your reliance on or use of such Third-Party Content, or any liability that may arise due to delays, interruptions, or inaccuracies in the delivery of the Third-Party Content for any reason.
            </p>
          </section>
        </div>
      </main>
      <Footer />
      <MobileNavBar
        isAuthenticated={isAuthenticated}
        isAdmin={isAdmin}
        isLoading={isLoading}
        isMenuOpen={isMenuOpen}
        toggleMenu={toggleMenu}
        handleLogout={handleLogout}
      />
    </div>
  );
};

export default RiskDisclaimer;
